<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 7/3/2021
  -->

<template>
	<qw-drawer
		v-model="showEditSessionType"
		:modal="modal"
		:size="drawerSize"
		:wrapperClosable="false"
		class="coaching-session-drawer-root"
		@close="onDrawerClosed"
		@change="onDrawerOpenStateChanged">
		<!--				<EventTypeSettingsView-->
		<!--					v-bind="$attrs"-->
		<!--					:hideMenu="true"-->
		<!--					class="py-3"/>-->

<!--		<router-view-->
		<EventTypeSettingsView
			v-bind="{...attrs, ...$attrs}"
			:eventTypeId="eventTypeId"
			:eventTypeProp="eventTypeProp"
			:showDrawerAsModal="false"
			:hideMenu="true"
			:hideToast="hideToast"
			@onSaved="onSaved"
			@onBackPressed="showEditSessionType = false"
			class="p-3"/>
	</qw-drawer>
</template>

<script>

import QwDrawer from "@/core/components/Form/QwoachDrawer.vue";
import QwoachDialog from "@/core/components/Dialogs/QwoachDialog/QwoachDialog.vue";
import EventTypeSettingsView from "@/core/modules/coach/Scheduler/EventTypes/EventTypeSettingsView.vue";
import EventType from "@shared/scheduler/EventType";
export default {
    name: "SessionTypeDrawer",
	components: {EventTypeSettingsView, QwDrawer},
	extends: QwoachDialog,

	props: {
		modal: {Boolean, default: true},
		showCompletedSessions:{Boolean, default: true},
		eventTypeId: String,
		eventTypeProp: EventType,

		tooltipAnalyticsProps: Object,
		analyticsProps: {Object, default: () => ({})},
		hideTitle: Boolean,
		drawerSize: String,
		showToast: {Boolean, default: true},
		attrs: null,
		hideToast: Boolean
	},

	data() {
		return {
			showEditSessionType: true
		}
	},

	methods: {

		onSaved(sessionType){
			console.log("SessionTypeDrawer: onSaved = ", sessionType)
			this.onOk(sessionType)
		},

		onDrawerClosed() {
			this.onCancel()
		},

		onDrawerOpenStateChanged(){
			this.$emit("onDrawerOpenStateChanged")
		}
	},
}
</script>

<style lang="scss">

</style>
